import { Container } from '@mui/material';
import styled from 'styled-components';

export const Selection = {
    Container: styled.div`
        padding: 10px;
    `,
    Title: styled.div`
        font-size: 1.5em;
        font-weight: bold;
        margin-bottom: 0.5em;
    `,
    Select: styled.select`
        padding: 0.5em;
        margin: 0.5em 0;
        border: 1px solid #ccc;
        border-radius: 4px;
    `,
    Option: styled.option`
        padding: 0.5em;
    `,
    Button: styled.button`
        padding: 0.5em 1em;
        margin-top: 1em;
        border: none;
        border-radius: 4px;
        background-color: #007bff;
        color: white;
        cursor: pointer;

        &:hover {
            background-color: #0056b3;
        }
    `
}

export const Table = {
    Container: styled.div`
        padding: 0 10px;
        padding-bottom: 100px;
    `,
}

export const BackupButton = {
    Container: styled.div`
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        button{
            width: 100px;
            background: var(--blueColor1);
            color:#fff;
            border:none;
        }
    `,
}

export const CustomDropdown = {
    Container: styled.div`
    
    `,
    MenuItemContent: styled.div`
        word-wrap: break-word;
        width: 100%;
        .uuid{
            word-wrap: break-word;
            width: 100%;
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }

        .backupAt{
            display: flex;
            justify-content: flex-end;
            font-size: 14px;
            color: #999;
        }
    `,
}

export const RecoveryNoticeModal = {
    Body: styled.div`
        padding: 10px;
        display: flex;
        flex-direction: column;
        .title{
            font-size: 1.5em;
            font-weight: bold;
            margin-bottom: 0.5em;
        }
        .message{
            font-size: 16px;
            margin-bottom: 0.5em;
        }
        button{
            padding: 0.5em 1em;
            margin-top: 1em;
            border: none;
            border-radius: 4px;
            background-color: #007bff;
            color: white;
            cursor: pointer;
    
            &:hover {
                background-color: #0056b3;
            }

            &.cancel{
                background-color: #efefef;
                color: #333;
            }
        }
    `,
}